<template>
  <div class="level">
    <div class="level-item">
      <div class="block has-text-centered flex-c">

        <!-- logo -->
        <img id="logo" class="image" src="@/assets/images/fend-logo.png">

        <!-- subtitle -->
        <div class="my-5">Multi-factor Authentication</div>

        <form v-on:submit.prevent="submit" novalidate class="mfa-form">
          <!-- email -->
          <div class="field">
            <div class="control">
              <input class="input" :class="{'is-danger': hasErrors}"
                     type="text" placeholder="Code" v-model="code">
            </div>
          </div>

          <!-- submit -->
          <div class="control">
            <button class="button is-fullwidth is-primary">Continue</button>
          </div>

          <div v-if="hasErrors" class="mt-4 mb-3 is-size-6 has-text-weight-light help is-danger">
            There was a problem authenticating, please check you code or try again.
          </div>
          <div v-else class="mt-4 mb-3 is-size-6 has-text-weight-light has-text-grey-dark">
            To continue, please enter the code sent to your saved phone number.
          </div>
        </form>

        <!-- login -->
        <div class="pt-4 is-size-6">
          <router-link class="has-text-primary" to="/login">Back to Login</router-link>
        </div>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { isEmpty } from 'lodash';
import { get } from 'vuex-pathify';

export default {
  name: 'mfa',
  data() {
    return {
      code: '',
      errors: {}
    };
  },
  computed: {
    mfa: get('mfa'),
    hasErrors() { return !isEmpty(this.errors); },
  },
  methods: {
    async submit() {
      try {
        await api.auth.mfa(this.mfa.username, this.mfa.tokens, this.code);
        this.errors = {};
        this.$router.push('/dashboard');
      } catch (error) {
        this.errors = error.data || {};
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #logo {
    max-width: 175px;
  }
  .level {
    flex-grow: 1;
    min-width:0; min-height:0;
  }
  .block {
    max-width: 400px;
  }
  .mfa-form {
    max-width: 300px;
  }
</style>
